import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import { labVatNumberWarningTemplate } from 'apollo/templates/organization/query.graphql';
import { useTranslation } from 'react-i18next';
import { Link as RouterLink } from 'react-router-dom';
import { Alert, Link } from '@mui/material';

type MissingVatNumberWarningProps = {
    /** Link to the invoice settings, where the VAT number is entered. Off on that page itself. */
    showSettingsLink?: boolean;
};

/**
 * DD-3700: invoices that charge VAT must show the lab's VAT number. The backend decides whether
 * this lab is affected (VAT on some of its actions or materials, no VAT number); this only shows it.
 */
const MissingVatNumberWarning: FC<MissingVatNumberWarningProps> = ({
    showSettingsLink = true,
}: MissingVatNumberWarningProps) => {
    const { t: translate } = useTranslation(['lab-settings']);
    const { data } = useQuery(labVatNumberWarningTemplate, { fetchPolicy: 'cache-and-network' });

    if (!data?.currentLab?.vatNumberMissingForTaxedItems) {
        return null;
    }
    return (
        <Alert severity="warning" sx={{ mb: 2 }}>
            {translate('lab-settings:VAT_NUMBER_MISSING_WARNING')}
            {showSettingsLink ? (
                <>
                    {' '}
                    <Link component={RouterLink} to="/lab-settings/invoicing">
                        {translate('lab-settings:VAT_NUMBER_MISSING_LINK')}
                    </Link>
                </>
            ) : undefined}
        </Alert>
    );
};

export default MissingVatNumberWarning;
